import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  identifier: yup.string().required().min(3).max(100).nullable(),
  expiration_date: yup.string().required().nullable(),
  quantity_limit: yup.number().required().nullable().moreThan(0),
  plan_coupon_status_id: yup.number().required().nullable().moreThan(0),
  discount_type: yup.string().required().nullable(),
  value: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value,
    )
    .when("discount_type", {
      is: "value",
      then: (schema) => schema.required().moreThan(0),
      otherwise: (schema) => schema.optional(),
    }),
  percent: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value,
    )
    .when("discount_type", {
      is: "percent",
      then: (schema) => schema.required().moreThan(0).max(100),
      otherwise: (schema) => schema.optional(),
    }),
});
